import type { OnQueryUpdated } from '@apollo/client';

export const invalidateRefetch: OnQueryUpdated<any> = async (observable) => {
  await observable.refetch();
};
